import React from 'react';
import { Shield, Award, CheckCircle } from 'lucide-react';
import PageBanner from '../layout/PageBanner';
import SectionHeading from '../ui/SectionHeading';

const CredentialsPage = () => {
  const credentials = [
    { name: 'SQF Level 2 Certification', icon: Shield },
    { name: 'ISO Certified', icon: Award },
    { name: 'USDA Certified', icon: CheckCircle },
    { name: 'Kosher Certification Available', icon: CheckCircle },
    { name: 'Organic Certification Available', icon: CheckCircle },
    { name: 'Gluten-Free Options', icon: CheckCircle },
  ];

  return (
    <div>
      <PageBanner
        title="Our Credentials"
        breadcrumbs={[{ label: 'OUR CREDENTIALS' }]}
      />

      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <SectionHeading
            title="Our Credentials"
            subtitle="Mirage Fine Foods maintains the highest standards in food manufacturing and safety."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {credentials.map((credential, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow"
              >
                <credential.icon size={48} className="text-primary-red mx-auto mb-4" />
                <h3 className="font-semibold text-gray-900">{credential.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CredentialsPage;
